import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { MeetingScheduler } from "../../types/Types";

export function useGetMeetingSchedulers({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    enabled,
    queryKey: ["meeting-schedulers"],
    queryFn: async () => {
      const res = await axiosInstance.get<MeetingScheduler[]>(
        getAPIURL("/MeetingScheduler/All")
      );
      return res.data ?? [];
    },
  });
}
